import { useState } from "react";
import { useStyletron } from "baseui";
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from "baseui/modal";
import { useGetTenantsQuery } from "../../../services/resourceGroups/tenantApi";
import { LoadingView } from "../../../components/LoadingView";
import { ListItem, ListItemLabel } from "baseui/list";
import { VscSymbolClass } from "react-icons/vsc";
import { useSetSubscriptionOwnerMutation } from "../../../services/resourceGroups/subscriptionApi";
import { useReportMutationState } from "../../../hooks/useReportMutationState";
import { FormattedMessage } from "react-intl";
import { ICompany } from "@oqdo/automationapps/Agents/Organizations/Company";

function SelectOwnerDialog(props: { subscriptionId: string; isOpen: boolean; setIsOpen: any }) {
  const { subscriptionId, isOpen, setIsOpen } = props;
  const [selected, setSelected] = useState<ICompany>();
  const [setOwner, setOwnerResult] = useSetSubscriptionOwnerMutation();
  useReportMutationState(setOwnerResult);
  const close = () => setIsOpen(false);
  const handleOk = async () => await setOwner({ id: subscriptionId, tenantId: selected?.id ?? "" });

  return (
    <>
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>
          <FormattedMessage id={"selectOwner"} defaultMessage={"Select owner"} />
        </ModalHeader>
        <ModalBody>
          <FormattedMessage id={"selectTenantFromList"} defaultMessage={"Select a Tenant from the list"} />

          <TenantsList selected={selected} setSelected={setSelected} subscriptionId={subscriptionId} />
        </ModalBody>
        <ModalFooter>
          <ModalButton kind="tertiary" onClick={close}>
            <FormattedMessage id={"cancel"} defaultMessage={"Cancel"} />
          </ModalButton>
          <ModalButton disabled={!selected} isLoading={setOwnerResult.isLoading} onClick={handleOk}>
            <FormattedMessage id={"ok"} defaultMessage={"Ok"} />
          </ModalButton>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default SelectOwnerDialog;

const TenantsList = (props: { subscriptionId: string; selected: ICompany | undefined; setSelected: any }) => {
  const [css, theme] = useStyletron();
  const { subscriptionId, selected, setSelected } = props;
  const { data: tenantsData, isLoading, isSuccess, isError, error } = useGetTenantsQuery(subscriptionId);
  const data = tenantsData?.data;
  return (
    <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
      {data?.map((item: ICompany, index) => (
        <span
          key={item.id}
          onClick={() => {
            setSelected(item);
          }}>
          {selected === item ? (
            <ListItem overrides={selectedListItemStyle} artwork={() => <VscSymbolClass />} key={item.id}>
              <ListItemLabel>{item.name}</ListItemLabel>
            </ListItem>
          ) : (
            <ListItem artwork={() => <VscSymbolClass />} key={item.id}>
              <ListItemLabel>{item.name}</ListItemLabel>
            </ListItem>
          )}
        </span>
      ))}
    </LoadingView>
  );
};

const selectedListItemStyle = {
  Root: {
    style: ({ $theme }) => ({
      backgroundColor: $theme.colors.accent100,
    }),
  },
};
